import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { formatCPF } from "@modules/users/utils/formatCPF";
import { useListPlansQuery } from "@modules/plans/services/queries";
import { useListUsersQuery } from "@modules/users/services/queries";
import { useListAgreementsQuery } from "@modules/agreements/services/queries";

export const useSubscriptionListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  subscriptionModalRef: RefObject<ModalRef>
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "user",
        headerName: translate("subscription_admin.fields.user"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => {
          if (value === null || value === undefined) {
            return <TableCell.Text value="-" textAlign="left" />;
          }
          return (
            <TableCell.Fetch
              resourceHook={useListUsersQuery}
              id={value}
              link="/users/edit"
              valueKey="full_name"
              textAlign="left"
            />
          );
        },
      },
      {
        field: "cpf",
        headerName: translate("subscription_admin.fields.cpf"),
        minWidth: 150,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text value={formatCPF(value)} textAlign="left" />
        ),
      },
      {
        field: "plan",
        headerName: translate("subscription_admin.fields.plan"),
        minWidth: 200,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Fetch
            resourceHook={useListPlansQuery}
            id={value}
            valueKey="display_name"
            textAlign="left"
          />
        ),
      },
      {
        field: "product",
        headerName: "Produto",
        minWidth: 200,
        sortable: false,
        headerAlign: "left",
        renderCell: ({ row }) => (
          <TableCell.Fetch
            resourceHook={useListPlansQuery}
            id={row.plan}
            valueKey="product_name"
            textAlign="left"
          />
        ),
      },
      {
        field: "start_date",
        headerName: translate("subscription_admin.fields.start_date"),
        minWidth: 140,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" showTime={false} />
        ),
      },
      {
        field: "valid_until",
        headerName: translate("subscription_admin.fields.valid_until"),
        minWidth: 140,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" showTime={false} />
        ),
      },
      /* {
        field: "agreement",
        headerName: "Convênio",
        minWidth: 200,
        headerAlign: "left",
        renderCell: ({ value }) => {


          console.log(value);
          return(
          <TableCell.Fetch
            resourceHook={useListAgreementsQuery}
            id={value}
            valueKey="name"
            link="/agreement/edit"
            textAlign="left"
          />
        )},
      }, */
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => subscriptionModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
              resource="v1/subscription_admin"
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, subscriptionModalRef]
  );
};
